var React = require('react');
var Apex = require('./apex.min.js');
Apex = Apex || window.ApexCharts;
import './apexcharts.css';

class ApexChart extends React.Component {
	constructor(props) {		
		super(props);	
		this.options = props.options || {};	
		this.series = this.options.series = props.series || {};
		this.style = props.style || {width: "100%", height: "100%", position: "relative"};
		this.chartRef = null;
		this.chart = null;
		this.setRef = (el => this.chartRef = el).bind(this);
	}	
	componentDidMount() { 
		//Create Chart and Render		
		this.chart = new Apex(this.chartRef, this.options);
		this.chart.render();
		
		if(this.props.onRef)
			this.props.onRef(this.chart);
	}	
	
	componentDidUpdate(prevProps) {
		if (!this.chart) return null
		this.options = this.props.options || {};	
		this.series = this.options.series = this.props.series || {};
		
		const prevOptions = JSON.stringify(prevProps.options)
		const prevSeries = JSON.stringify(prevProps.series)
		const currentOptions = JSON.stringify(this.props.options)
		const currentSeries = JSON.stringify(this.props.series)
		
		if(prevOptions !== currentOptions){
			this.chart.updateOptions(this.options);
		}
		else if(currentSeries !== prevSeries){
			this.chart.updateSeries(this.series);
		}
	}
	componentWillUnmount() {
		//Destroy chart and remove reference
		this.chart.destroy();
		if(this.props.onRef)
			this.props.onRef(undefined);
	}		
	render() {
		return React.createElement('div', { 
		ref: this.setRef,
		style: this.style,
		...this.props
		});		
		
	}	
}

export {ApexChart, Apex};